import * as d3 from 'd3'

export const IMPLIED_RATING_DOMAIN = ['A', 'AA', 'B', 'BB', 'BBB']

export const getChartColorRange = keyLength => {
  return [
    '#DAE3F1',
    '#B7CDE9',
    '#6F95C8',
    '#426CA6',
    '#214578',
    '#156ed3',
  ].splice(0, keyLength)
}

export const getCircleColor = impliedRating => {
  const d3ScaleSize = d3
    .scaleOrdinal()
    .domain(IMPLIED_RATING_DOMAIN)
    .range(['#19ceff', '#a0d1ef', '#70aae7', '#2781d9', '#066b7f'])

  return d3ScaleSize(impliedRating)
}

export const FUNDAMENTAL_TOGGLE_COLOR = {
  COMPANY_HISTORY: '#3073C3',
  POD_COMPARE1: '#7F56D9',
  POD_COMPARE2: '#FF0000',
  POD_COMPARE3: '#d7b804',
  PEER_GROUP: '#BF8264',
  EQUITY_PRICE: '#256ABD',
  ASSET_VOLATILITY: '#BF8264',
  LEVERAGE: '#C84747',
  MARKET_VALUE_OF_ASSET: '#256ABD',
  UNRECOGNISED_RISK_STATUS: '#1B3963',
  RISK_EVENTS: '#1B3963',
  COMPANY_HISTORY_FC: '#BF8264',
  PEER_GROUP_FC: '#FF5500',
}

export const TOGGLE_INDEX = {
  COMPANY_HISTORY: 1,
  PEER_GROUP: 2,
  EQUITY_PRICE: 3,
  ASSET_VOLATILITY: 4,
  LEVERAGE: 5,
  MARKET_VALUE_OF_ASSET: 6,
  UNRECOGNISED_RISK_STATUS: 7,
  RISK_EVENTS: 8,
}

export const getDotSize = impliedRating => {
  const d3ScaleSize = d3
    .scaleOrdinal()
    .domain(IMPLIED_RATING_DOMAIN)
    .range([3, 4, 5, 5.5, 6])

  return d3ScaleSize(impliedRating)
}

export const countYAxisTick = data => {
  return (
    d3.max(data, d => d.date.getFullYear()) -
    d3.min(data, d => d.date.getFullYear()) +
    1
  )
}

export const getImpliedRatingChangeColor = impliedRatingChange => {
  return impliedRatingChange === 2 ? '#758396' : '#1B3963'
}

export const getTrendColor = rating_trend => {
  return TREND_COLOR[rating_trend]
}

export const TREND_COLOR = {
  Positive: '#32AE6C',
  Stable: '#758396',
  Negative: '#DE3131',
  Default: '#1B3963',
}

export const getTrendSymbol = rating_trend => {
  return TREND_SYMBOL[rating_trend]
}

export const TREND_SYMBOL = {
  Positive: '+',
  Stable: '',
  Negative: '-',
  Default: '',
}

export const formatPercentageNumber = number => {
  return !isNaN(number) ? Number(number * 100).toFixed(2) * 1 : number
}

// need to update logic
// show scan chart if one of stack area chart is not empty
// and less than 2 scan charts empty
export const showingScanChart = charts => {
  const stackAreaChecked =
    charts.filter(
      c => c.type === 'StackedAreaChart' && c.data && c.data.length > 1,
    ).length > 1

  const scanChartChecked =
    charts.filter(c => c.type === 'LineChart' && c.data && c.data.length > 1)
      .length >= 4

  return stackAreaChecked && scanChartChecked
}

export const RISK_STATUS_CONST = ['Neutral', 'Watchlist', 'Smoke', 'Fire']
export const RISK_STATUS_COLOR_SCALE = {
  High: '#800202',
  Medium: '#D10000',
  Low: '#FF5C5C',
  Neutral: '#BBBFC7',
  Fire: '#DE1313',
  Smoke: '#ED5F5F',
  Watchlist: '#E39193',
  Total: '#1D82F9',
}
export const RISK_STATUS_BORDER_COLOR_SCALE = {
  High: '#800202',
  Medium: '#D10000',
  Low: '#FF5C5C',
  Neutral: '#FFFFFF',
  Fire: '#F5A6A6',
  Smoke: '#FBD4D5',
  Watchlist: '#E8A6A7',
  Total: '#A3CCFB',
}
export const riskStatusData = [
  { id: 'Fire', value: 'Fire', isChecked: false, type: 'equityRisk' },
  { id: 'Smoke', value: 'Smoke', isChecked: false, type: 'equityRisk' },
  { id: 'Watchlist', value: 'Watchlist', isChecked: false, type: 'equityRisk' },
  { id: 'Neutral', value: 'Neutral', isChecked: false, type: 'equityRisk' },
]
export const creditRiskStatusData = [
  { id: 'HighCreditRisk', value: 'Fire', isChecked: false, type: 'creditRisk' },
  {
    id: 'MediumCreditRisk',
    value: 'Smoke',
    isChecked: false,
    type: 'creditRisk',
  },
  {
    id: 'LowCreditRisk',
    value: 'Watchlist',
    isChecked: false,
    type: 'creditRisk',
  },
  {
    id: 'NeutralCreditRisk',
    value: 'Neutral',
    isChecked: false,
    type: 'creditRisk',
  },
]

export const mappingMarbleData = (item, getValue) => {
  if (item === 'Total') {
    getValue({ name: 'total' })
  } else {
    getValue({ name: item })
  }
}

export const getCompanyStatus = status => {
  switch (status) {
    case 'Medium':
      return 'Smoke'
    case 'Neutral':
      return 'Neutral'
    case 'Low':
      return 'Watchlist'
    case 'High':
      return 'Fire'
    case 'Watchlist':
      return 'Watchlist'
    case 'Neutral':
      return 'Neutral'
    case 'Smoke':
      return 'Smoke'
    case 'Fire':
      return 'Fire'
    default:
      return 'Neutral'
  }
}

export const filterByRiskType = (item, riskType, level) => {
  return riskType === RISK_TYPE.EQUITY
    ? item.risk_outlook === level
    : item.credit_status === level
}

export const getCompanyStatusWithType = (status, type) => {
  switch (status) {
    case 'Smoke':
      return 'Smoke'
    case 'Neutral':
      return 'Neutral'
    case 'Watchlist':
      return 'Watchlist'
    case 'Fire':
      return 'Fire'
    default:
      return 'Neutral'
  }
}

export const RISK_TYPE = {
  EQUITY: 'EQUITY',
  CREDIT: 'CREDIT',
}

export const commonMapFilter = list => {
  return list.map(i => {
    let a =
      i.risk_outlook === 'Fire'
        ? 1
        : i.risk_outlook === 'Smoke'
        ? 2
        : i.risk_outlook === 'Watchlist'
        ? 3
        : 4
    let b =
      i.prev_status === 'High'
        ? 1
        : i.prev_status === 'Medium'
        ? 2
        : i.prev_status === 'Low'
        ? 3
        : 4
    let a1 =
      i.credit_status === 'High'
        ? 1
        : i.credit_status === 'Medium'
        ? 2
        : i.credit_status === 'Low'
        ? 3
        : 4
    let b1 =
      i.prev_credit_status === 'High'
        ? 1
        : i.prev_credit_status === 'Medium'
        ? 2
        : i.prev_credit_status === 'Low'
        ? 3
        : 4
    return {
      ...i,
      sortByEquityRisk: `${a}${b}`,
      sortByCreditRisk: `${a1}${b1}`,
    }
  })
}
